export const FULL_PERMISSIONS_LIST = [
    "raven:ReadRavens",          // 1 - Read raven data
    "raven:WriteRavens",         // 2 - Write raven data
    "raven:ReadEvents",          // 3 - Read raven event data
    "raven:WriteEvents",         // 4 - Write raven event data
    "raven:ReadStatus",          // 5 - Read raven status data
    "raven:ViewCamera",          // 6 - View raven camera
    "raven:ViewVideoStream",      // 7 - View raven streams
    "raven:ReadSettings",        // 8 - Read raven settings
    "raven:WriteSettings",       // 9 - Write raven settings
    "raven:TripShare",           // 10 - Share raven trip data
    "raven:ReadMedia",           // 11 - Read raven media files
    "raven:RequestMedia",          // 12 - Request raven media files
    "raven:DriverMessaging",     // 13 - Send messages to a driver via a Raven
    "raven:AssignDriver",        // 14 - Assign a driver to a Raven
    "raven:ReadSessions",        // 15 - Read session data from a Raven
    "raven:WriteSessions",       // 16 - Write session data to a Raven
    "raven:ReadServicePlans",    // 17 - Read service plan for a Raven
    "raven:WriteServicePlans",   // 18 - Write service plan for a Raven
    "raven:ReadNotifications",   // 19 - Read notifications from a Raven
    "raven:WriteNotifications",  // 20 - Write notifications to a Raven
    "raven:WriteCarPersona",     // 21 - Write car persona for a Raven
    "account:ReadSettings",      // 101 - Read account settings
    "account:WriteSettings",     // 102 - Write account settings
    "account:ReadAssets",        // 103 - Read assets and beacons on an account
    "account:WriteAssets",       // 104 - Write assets and beacons on an account
    "account:ReadGeofences",     // 105 - Read geofences on an account
    "account:WriteGeofences",    // 106 - Write geofences on an account
    "account:ReadIntegrations",  // 107 - Read integrations on an account
    "account:WriteIntegrations", // 108 - Write integrations on an account
    "account:ReadBilling",       // 109 - Read billing information on an account
    "account:WriteBilling",      // 110 - Write billing information on an account
    "account:ReadUsers",         // 111 - Read users on an account
    "account:WriteUsers",        // 112 - Write users on an account
    "account:ReadRekognition",   // 113 - Read rekognition data on an account
    "account:WriteRekognition",  // 114 - Write rekognition data on an account
    "tag:ReadTags",              // 201 - Read tags on an account
    "tag:WriteTags",             // 202 - Write tags on an account
];

export const ACCOUNT_PERMISSIONS_LIST = [
    "account:ReadSettings",      // 101 - Read account settings
    "account:WriteSettings",     // 102 - Write account settings
    "account:ReadAssets",        // 103 - Read assets and beacons on an account
    "account:WriteAssets",       // 104 - Write assets and beacons on an account
    "account:ReadGeofences",     // 105 - Read geofences on an account
    "account:WriteGeofences",    // 106 - Write geofences on an account
    "account:ReadIntegrations",  // 107 - Read integrations on an account
    "account:WriteIntegrations", // 108 - Write integrations on an account
    "account:ReadBilling",       // 109 - Read billing information on an account
    "account:WriteBilling",      // 110 - Write billing information on an account
    "account:ReadUsers",         // 111 - Read users on an account
    "account:WriteUsers",        // 112 - Write users on an account
    "account:ReadRekognition",   // 113 - Read rekognition data on an account
    "account:WriteRekognition",  // 114 - Write rekognition data on an account
];